// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  display: block !important;
}

.mobile-web-toolbar {
  height: 35px;
}
.mobile-web-toolbar ion-button {
  margin-top: 0;
  --padding-top: 0px;
  --padding-bottom: 20px;
}

ion-title {
  font-family: var(--font-secondary);
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: var(--ion-color-dark);
}

@media screen and (max-width: 550px) {
  ion-title {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/lobby/custom-navbar/custom-navbar.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AACA;EACI,YAAA;AAEJ;AADI;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;AAGR;;AAAA;EACI,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAGJ;;AAAA;EACI;IACI,eAAA;EAGN;AACF","sourcesContent":["ion-toolbar{\n    display: block !important;\n}\n.mobile-web-toolbar{\n    height: 35px;\n    ion-button{\n        margin-top: 0;\n        --padding-top: 0px;\n        --padding-bottom: 20px;\n    }\n}\nion-title {\n    font-family: var(--font-secondary);\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    color: var(--ion-color-dark);\n}\n\n@media screen and (max-width: 550px) {\n    ion-title {\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
